import React, { Component, ReactNode } from "react";

interface Props {
    errorMessage?: string | ReactNode;
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <p>{this.props.errorMessage}</p>;
        }

        return this.props.children;
    }
}